import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { RootState } from "..";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { typedAction } from "../helpers";
import { ISharedItems } from "../models/reduxModels";
import { getSharedFiles } from "../../services/GraphService";
import {
  RESET_USER_SHARED_ITEMS,
  SET_USER_SHARED_ITEMS,
  SET_SHARED_IS_LOADING
} from "./actionTypes";
import { RecentFilesMapper } from "../../components/mappers/recentFilesMapper";
import { logger } from "../../../../utilities/logger";

const initialState: ISharedItems = {
  isSharedItemsLoading: false,
  sharedItems: null
};

const setIsSharedItemsLoading = (isSharedItemsLoading: boolean) => {
  return typedAction(SET_SHARED_IS_LOADING, isSharedItemsLoading);
};

export const getSharedItems = (languageStrings: any): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch, getState) => {
  dispatch(setIsSharedItemsLoading(true));
  let sharedItems: IStoreItem[];
  try {
    const graphSharedItems = await getSharedFiles();
    if (graphSharedItems) {
      sharedItems = new RecentFilesMapper(languageStrings, true).map(graphSharedItems);
    }
  } catch (error) {
    logger(error, "shareItems.ts (getSharedItems)");
  }
  dispatch(setSharedItems(sharedItems ?? []));
};

export const setSharedItems = (sharedItems: IStoreItem[]) => {
  return typedAction(SET_USER_SHARED_ITEMS, sharedItems);
};

export const resetSharedItems = () => {
  return typedAction(RESET_USER_SHARED_ITEMS);
};

type HomeAction = ReturnType<
  | typeof setSharedItems
  | typeof resetSharedItems
  | typeof setIsSharedItemsLoading
>;

export function sharedReducer(state = initialState, action: HomeAction): ISharedItems {
  switch (action.type) {
    case SET_SHARED_IS_LOADING:
      return { ...state, isSharedItemsLoading: action.payload };
    case SET_USER_SHARED_ITEMS:
      return { isSharedItemsLoading: false, sharedItems: action.payload };
    case RESET_USER_SHARED_ITEMS:
      return initialState;
    default:
      return state;
  }
};